import { render, staticRenderFns } from "./appSetDialog.vue?vue&type=template&id=5185b0c1&scoped=true"
import script from "./appSetDialog.vue?vue&type=script&lang=js"
export * from "./appSetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185b0c1",
  null
  
)

export default component.exports